import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, formatCurrency, publicPdfUrl } from "@/lib/api";
import { Check, Download } from "lucide-react";

export default function PaymentSuccess() {
  const { id } = useParams();
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    api.get(`/public/invoices/${id}`).then((r) => setInvoice(r.data)).catch(() => {});
  }, [id]);

  return (
    <div
      className="min-h-screen flex items-center justify-center p-8 bg-white"
      data-testid="payment-success-page"
    >
      <div className="max-w-lg w-full space-y-8 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center">
          <Check className="text-emerald-700" size={28} />
        </div>
        <div className="space-y-2">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
            Payment Received
          </p>
          <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-zinc-900">
            Thank you.
          </h1>
          {invoice && (
            <p className="text-zinc-500">
              {formatCurrency(invoice.total, invoice.currency)} settled on invoice{" "}
              <span className="font-mono text-zinc-900">
                {invoice.invoice_number}
              </span>
              .
            </p>
          )}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {invoice && (
            <a
              href={publicPdfUrl(invoice.id)}
              target="_blank"
              rel="noreferrer"
              data-testid="success-download-pdf"
              className="inline-flex items-center gap-2 bg-zinc-900 text-white rounded-none px-6 py-3 text-sm font-medium hover:bg-zinc-800 transition-colors"
            >
              <Download size={14} /> Download receipt
            </a>
          )}
          <Link
            to={`/pay/${id}`}
            data-testid="success-back-link"
            className="inline-flex items-center gap-2 bg-transparent text-zinc-900 border border-zinc-200 rounded-none px-6 py-3 text-sm font-medium hover:border-zinc-900 transition-colors"
          >
            View invoice
          </Link>
        </div>
      </div>
    </div>
  );
}
